<template>
    <div
        class="footer container"
        :class="{
            'footer-unauth': isEmpty('user'),
            'footer-auth container': !isEmpty('user'),
        }"
    >
        <ul class="menu">
            <li class="menu-item">
                <!-- <redirectButton
                    pathname="about"
                    html="О сайте"
                    class="link"
                ></redirectButton> -->
                <router-link :to="{ name: 'about' }" class="link">
                    {{ $t("footer.footerAbout") }}
                </router-link>
            </li>
            <li class="menu-item">
                <!-- <redirectButton
          pathname="rules"
          html="Правила"
          class="link"
        ></redirectButton> -->
                <router-link :to="{ name: 'rules' }" class="link">
                    {{ $t("footer.footerRules") }}
                </router-link>
            </li>
            <li class="menu-item">
                <!-- <redirectButton
          pathname="help"
          html="Помощь"
          class="link"
        ></redirectButton> -->
                <router-link :to="{ name: 'help' }" class="link">
                    {{ $t("footer.footerHelps") }}
                </router-link>
            </li>
            <li class="menu-item">
                <!-- <redirectButton
          pathname="legal"
          html="Юридическая информация"
          class="link"
        ></redirectButton> -->
                <router-link :to="{ name: 'legal' }" class="link">
                    {{ $t("footer.footerLegal") }}
                </router-link>
            </li>
            <li class="menu-item">
                <!-- <redirectButton
          pathname="feedback"
          html="Обратная связь"
          class="link"
        ></redirectButton> -->
                <router-link :to="{ name: 'feedback' }" class="link">
                    {{ $t("footer.footerFeedback") }}
                </router-link>
            </li>
            <!-- <li class="menu-item">
                <redirectButton
                    pathname="advertising"
                    html="Реклама"
                    class="link"
                ></redirectButton>
            </li>
            <li class="menu-item">
                <redirectButton
                    pathname="developers"
                    html="Разработчикам"
                    class="link"
                ></redirectButton>
            </li> -->
            <!-- <li class="menu-item menu-item-developer">
        <a href="http://my-green.ru/"></a>
      </li> -->
        </ul>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";

export default {
    name: "Footer",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            isEmpty: "user/isEmpty",
        }),
    },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/layout/_footer";
</style>
